import { useEffect, useState } from 'react';

/**
 * Subtle floating "Back to top" button.
 * Fades in once the visitor has scrolled down a meaningful amount, so it only
 * appears on longer pages and never competes with the top of the page.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed right-5 md:right-6 bottom-24 lg:bottom-6 z-40 flex items-center gap-1.5 rounded-full bg-primary-500 text-white pl-3 pr-4 py-2.5 text-sm font-bold whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-primary-600 ${
        visible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <span className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-up-line text-lg"></i>
      </span>
      Top
    </button>
  );
}